module.exports = __webpack_public_path__ + "static/media/tom-ford-black-orchid-big.351e4d76.png";